// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-EjkyKN","radioItem":"radioItem-B_CsRm","label":"label-n7D07N","patientGrid":"patientGrid-KjqJek","patientName":"patientName-QvVl7P"};